import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./reporter/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'welcome/:tenantId',
    loadChildren: () => import('./reporter/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: '',
    redirectTo: 'admin-main',
    pathMatch: 'full'
  },
  {
    path: 'pdm-policy',
    loadChildren: () => import('./reporter/pdm-policy/pdm-policy.module').then( m => m.PdmPolicyPageModule)
  },
  {
    path: 'report-incident',
    loadChildren: () => import('./reporter/incident-type/incident-type.module').then( m => m.IncidentTypePageModule)
  },
  {
    path: 'incident-main',
    loadChildren: () => import('./reporter/incident-main/incident-main.module').then( m => m.IncidentMainPageModule)
  },
  {
    path: 'incident-report',
    loadChildren: () => import('./reporter/incident-report/incident-report.module').then( m => m.IncidentReportPageModule)
  },
  {
    path: 'view-incident',
    loadChildren: () => import('./reporter/view-incident/view-incident.module').then( m => m.ViewIncidentPageModule)
  },
  {
    path: 'admin-main',
    loadChildren: () => import('./admin/admin-main/admin-main.module').then( m => m.AdminMainPageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./admin/onboarding/onboarding.module').then( m => m.OnboardingPageModule)
  },
  {
    path: 'brand-expo',
    loadChildren: () => import('./brand-expo/brand-expo.module').then( m => m.BrandExpoPageModule)
  },
  {
    path: 'incident-exported-file/:zipFileKeyEncoded/:iv/incident/:incidentId',
    loadChildren: () => import('./incident-exported-file/incident-exported-file.module').then( m => m.IncidentExportedFileModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
